// extracted by mini-css-extract-plugin
export var logo = "_kc-2";
export var logoWrapper = "_kc-1";
export var strip = "_kc-0";